import { createGlobalStyle } from 'styled-components';
import { media } from 'ia-react-core';
import errorIcon from '../../../assets/error.svg';
import visibilityIcon from '../../../assets/visibility.svg';
import visibilityOffIcon from '../../../assets/visibility-off.svg';
import rememberMeChecked from '../../../assets/rememberMeChecked.svg';
import rememberMeUnchecked from '../../../assets/rememberMeUnchecked.svg';

export const WidgetGlobalStyles = createGlobalStyle<{ borderRadius: boolean }>`
  #okta-sign-in.auth-container input[type=button], #okta-sign-in.auth-container input[type=submit],
  #okta-sign-in.auth-container .enroll-manual-push a.button-primary,
  #okta-sign-in.auth-container .enroll-totp a.button.button-primary.default-custom-button.link-button,
  #okta-sign-in.auth-container .auth-content .custom-password-expired a.button.button-primary.link-button,
  #okta-sign-in.auth-container .button.button-primary.js-enroll-phone.margin-top-30.call-request-button.link-button,
  #okta-sign-in.auth-container .button.button-primary.js-enroll-phone.margin-top-30.sms-request-button.link-button,
  #okta-sign-in.auth-container a.button.link-button
  {
    position: relative;
    display: inline-table;
    height: fit-content;
    min-height: 50px;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    padding: 13px 32px;
    border-radius: 50px;
    border: 0;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    -webkit-appearance: none;
    line-height: normal;
    text-decoration: none;
    outline: none;
    white-space: nowrap;
    word-wrap: normal;
    text-wrap: wrap;
  
    &:hover {
      background: ${({ theme }) => theme.colors.light} !important;
    }
  
    &[disabled], &:disabled {
      background: ${({ theme }) => theme.colors.disabled} !important;
      font-style: ${({ theme }) => theme?.Button?.disabledFontStyle} !important;
      cursor: default;
    }
  
    &:focus {
      box-shadow: none !important;
    }

    :not([disabled]), :not(:disabled) {
      &:focus, &:active  {
      background: ${({ theme }) => theme.colors.lighter} !important;
      }
    }
  }

  #okta-sign-in.auth-container .primary-auth-form .okta-form-input-field, 
  #okta-sign-in.auth-container .mfa-verify .okta-form-input-field
  {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
    font-size: ${({ theme }) => theme.fontSize.base}px !important;
    background: ${({ theme }) => theme.colors.white};
    appearance: none;
    outline: 0;
    padding: 9px 12px 8px 12px;
    border-radius: ${({ theme }) => theme?.Input?.borderRadius};
    font-family: ${({ theme }) => theme?.fontFamily?.regular} !important;
    line-height: 18px !important;
    border-color: ${({ theme }) => theme?.Input?.borderColor || theme.colors.mediumGray};
  
    :not([disabled]), :not(:disabled) {
      :hover {
          border-color: ${({ theme }) => theme?.colors.light};
          border-width: 2px;
          padding: 8px 11px 7px 11px;
      }
    }

    [disabled], :disabled {
      background: ${({ theme }) => theme.colors.gray1};
      font-style: ${({ theme }) => theme?.Input?.disabledFontStyle};
      color: ${({ theme }) => theme?.Input?.disabledColor};
    }
  }

  #okta-sign-in .o-form .o-form-input input[name=passCode] {
    text-indent: 1em !important;
  }

  #okta-sign-in .o-form .o-form-input input[name=nextPassCode], 
  #okta-sign-in .o-form .o-form-input input[name=passCode],
  #okta-sign-in.auth-container .o-form-input-name-passCode.okta-form-input-field
  {
    padding: 1px 1px 1px 1px !important;
    width: 100%;
    box-sizing: border-box;
    font-size: ${({ theme }) => theme.fontSize.base}px !important;
    background: ${({ theme }) => theme.colors.white};
    appearance: none;
    outline: 0;
    border-radius: ${({ theme }) => theme?.Input?.borderRadius};
    font-family: ${({ theme }) => theme?.fontFamily?.regular} !important;
    line-height: 18px !important;
    letter-spacing: normal !important;
  
    :not([disabled]), :not(:disabled) {
      :hover {
          border-color: ${({ theme }) => theme?.colors.lighter};
          padding: 0px 0px 0px 0px !important;
          border-width: 2px;
      }
      :active {
          border-color: ${({ theme }) => theme?.colors.lighter};
          padding: 0px 0px 0px 0px !important;
          border-width: 2px;
      }
    }

    [disabled], :disabled {
      background: ${({ theme }) => theme.colors.gray1};
      font-style: ${({ theme }) => theme?.Input?.disabledFontStyle};
      color: ${({ theme }) => theme?.Input?.disabledColor};
    }
  }

  #okta-sign-in .o-form-explain.o-form-input-error
  {
    color: ${({ theme }) => theme?.colors.error};
    display: none;
    padding-left: 18px;
    position: relative;
    word-break: break-word !important;
  }

  #okta-sign-in.auth-container .okta-form-input-field.input-fix 
  {
    border-color: ${({ theme }) => theme.colors.gray13};
  }

  #okta-sign-in.auth-container input[type=text],
  #okta-sign-in.auth-container input[type=tel], 
  #okta-sign-in.auth-container input[type=password]
  {
    color: ${({ theme }) => theme?.colors.text} !important;
  }

  #okta-sign-in.auth-container .primary-auth .input-fix input[type=text],
  #okta-sign-in.auth-container .primary-auth .input-fix input[type=password],
  #okta-sign-in.auth-container .mfa-verify .input-fix input[type=text],
  #okta-sign-in.auth-container .mfa-verify .input-fix input[type=tel]
  {
    padding: 0;
  }

  #okta-sign-in.auth-container .okta-form-input-field.focused-input,
  #okta-sign-in.auth-container .okta-form-input-field:focus
  {
    outline: none;
    border-color: ${({ theme }) => theme?.colors.blue10} !important;
    border: solid 2px ${({ theme }) => theme?.colors.blue10};
  }

  #okta-sign-in .focused-input, 
  #okta-sign-in input[type=text]:focus,
  #okta-sign-in input[type=radio]:focus+label,
  #okta-sign-in .link.help:focus
  {
    box-shadow: none !important;
  }

  #okta-sign-in.auth-container .input-fix.okta-form-input-field.o-form-has-errors
  {
    border: solid 2px ${({ theme }) => theme?.colors.error};
    border-color: ${({ theme }) => theme?.colors.error};
    :hover {
      border-color: ${({ theme }) => theme?.colors.error};
    }
  }

  #okta-sign-in.auth-container .okta-form-input-error.o-form-explain
  {
    color: ${({ theme }) => theme?.colors.error};
    font-weight: 600;
  }

  #okta-sign-in.auth-container .okta-form-input-error.o-form-explain .error-16-small::before
  {
    background-color: ${({ theme }) => theme?.colors.error};
    mask-image: url(${errorIcon});
    mask-size: cover;
    height: 18px;
    width: 18px;
    content: '';
  }

  #okta-sign-in .password-toggle .visibility-16::before
  {
    background-color: ${({ theme }) => theme.colors.light};
    mask-image: url(${visibilityIcon});
    mask-size: cover;
    height: 24px;
    width: 24px;
    content: '';
  }

  #okta-sign-in .password-toggle .visibility-off-16::before
  {
    background-color: ${({ theme }) => theme.colors.light};
    mask-image: url(${visibilityOffIcon});
    mask-size: cover;
    height: 24px;
    width: 24px;
    content: '';
  }

  #okta-sign-in.auth-container .o-form-input-name-password.input-fix .password-with-toggle
  {
    padding-right: 35px !important;
    width: 92%;
  }

  #okta-sign-in.auth-container .o-form .input-fix .password-toggle .eyeicon
  {
    right: 8px;
    padding: 4px 2px;
    opacity: 1;
  }

  #okta-sign-in.auth-container .o-form-label label,
  #okta-sign-in .enroll-totp .o-form-label legend
  {
    font-weight: bold !important;
    line-height: 1.29 !important;
    color: ${({ theme }) => theme.colors.black} !important;
  }

  #okta-sign-in div.enroll-totp div.o-form-label {
    margin-bottom: 12px;
  }

  #okta-sign-in span.registration-label
  {
    display: none !important;
  }

  #okta-sign-in .o-form .custom-checkbox
  {
    padding-top: 8px;
  }

  #okta-sign-in .custom-checkbox label
  {
    font-size: ${({ theme }) => theme.fontSize.base}px !important;
    padding-left: 28px;
  }

  #okta-sign-in.auth-container .o-form-content.o-form-theme.clearfix
  {
    padding-bottom: 36px;
  }

  #okta-sign-in.auth-container div.enroll-manual-push .o-form-content.o-form-theme.clearfix,
  #okta-sign-in.auth-container div.enroll-manual-totp .o-form-content.o-form-theme.clearfix
  {
    padding-bottom: 0;
  }

  #okta-sign-in.auth-container .o-form-content.o-form-theme.clearfix,
  #okta-sign-in.auth-container .o-form-content .scan-instructions.clearfix
  {
    padding-top: 36px;
  }
  
  .chzn-container-single.chzn-single,
  #okta-sign-in.auth-container .o-form-fieldset-container
  {
    margin-top: 20px;
  }
  
  #okta-sign-in.auth-container .o-form-error-container
  {
    margin-bottom: 26px;
  }

  #okta-sign-in.auth-container .auth-footer .help-links a.link, 
  #okta-sign-in.auth-container a.inline-link,
  #okta-sign-in.auth-container .scan-instructions-qrcode-wrapper.link
  {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 1.29;
    background: transparent;
    border: 0;
    padding: 0;
    outline: 0;
  
    &:hover, &:focus {
      text-decoration: underline;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.light};
    }

    &:active {
      color: ${({ theme }) => theme.colors.lighter};
      text-decoration: underline;
      cursor: pointer;
    }

    &:visited {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  #login-widget
  {
    padding-bottom: 0px;
    ${media.sm`
      padding-bottom: 200px;
    `}
  }

  #okta-sign-in .beacon-container
  {
    top: 35px;
  }

  #okta-sign-in.no-beacon .auth-content
  {
    padding-bottom: 0;
  }

  #okta-sign-in.no-beacon .auth-content .custom-password-expired
  {
    padding-top: 54px;
    padding-bottom: 36px;
  }

  #okta-sign-in.auth-container .custom-password-expired .o-form-content.o-form-theme.clearfix
  {
    padding-bottom: 0;
    padding-top: 0;
  }

  #okta-sign-in.auth-container .custom-password-expired .okta-form-subtitle
  {
    margin-bottom: 36px;
    padding-top: 0;
  }

  #okta-sign-in .o-form .infobox.infobox-error
  {
    padding: 24px 16px 24px 65px !important;
    background-color: ${({ theme }) => theme.colors.red15};
    border-radius: 4px;
    border: solid 1px ${({ theme }) => theme?.colors.error};
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 25px;
  }

  #okta-sign-in .o-form .infobox::before
  {
    display: none;
  }

  #okta-sign-in .o-form .infobox .icon
  {
    position: absolute;
    display: inline-block;
    float: left;
    top: 50%;
    margin-top: -24px;
  }

  #okta-sign-in .o-form .infobox .icon.error-16:before,
  #okta-sign-in .o-form .infobox .icon.error-24:before
  {
    position: relative;
    background-color: ${({ theme }) => theme?.colors.error};
    mask-image: url(${errorIcon});
    mask-size: cover;
    height: 48px;
    width: 48px;
    content: '';
  }

  @media only screen and (max-width: 600px)
  {
    #okta-sign-in .o-form .infobox .icon
    {
      float: none;
    }

    #okta-sign-in .o-form .infobox .icon.error-16:before,
    #okta-sign-in .o-form .infobox .icon.error-24:before
    {
      bottom: 0;
    }

    #okta-sign-in .enroll-sms .enroll-sms-phone
    {
      width: 100%;
    }
  }
  
  #okta-sign-in * {
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.fontFamily.regular} !important;
  }

  #okta-sign-in .auth-header {
    display: block;
    padding: 60px 0px 0px 0px !important;
  }
  #okta-sign-in.no-beacon .auth-header {
    padding: 0px 0px 0px 0px !important;
  }
  #okta-sign-in.auth-container.main-container {
    border-width: 0;
    box-shadow: none !important;
    width: 100%;
    max-width: 560px;
    border-radius: ${({ borderRadius }) => borderRadius ? '0 0 4px 4px' : '4px'} ;
    margin: auto;
    outline: none;
    overflow: hidden;
  }

  #okta-sign-in .primary-auth .okta-form-title,
  #okta-sign-in div.custom-password-expired .okta-form-title {
    display: none;
  }

  #okta-sign-in.auth-container .o-form-explain.okta-form-subtitle, 
  #okta-sign-in.auth-container .enroll-factor-description h3
  {
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
    font-weight: bold;
  }

  #okta-sign-in.auth-container .enroll-factor-description p
  {
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }

  #okta-sign-in.auth-container .enroll-factor-row .enroll-factor-button a {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 1.29;
    height: auto;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
    padding: 11px 16px;
    border-radius: 4px;
    border: 0;
    text-decoration-line: none;
    min-height: 40px;

    &:hover {
      background: ${({ theme }) => theme.colors.light};
    }

    &:focus, &:active  {
      background: ${({ theme }) => theme.colors.blue10};
    }
  }

  #okta-sign-in.auth-container a.button.link-button[data-se=sms-send-code],
  #okta-sign-in.auth-container a.button.link-button[data-se=make-call] {
    width: 100%;
    border-radius: 50px !important;
  }

  #okta-sign-in .scan-instructions .scan-instructions-details-wrapper .scan-instructions-details
  {
    margin-bottom: 20px;
    padding-right: 0px !important;
  }

  #okta-sign-in .barcode-scan .scan-instructions .scan-instructions-details-wrapper,
  #okta-sign-in .barcode-scan .scan-instructions .scan-instructions-qrcode-wrapper
  {
    float: none;        
  }

  #okta-sign-in .link.manual-setup {
    text-align: left !important;
    display: block;
    margin-top: 12px
  }

  #okta-sign-in.auth-container .qrcode-wrap
  {
    background: ${({ theme }) => theme.colors.gray2} !important;
  }

  #okta-sign-in.auth-container .qrcode-wrap .qrcode-image
  {
    position: inherit;    
    margin: auto;
    margin-top: 11px;
    margin-bottom: 11px;
    display: inline-block;    
    text-align: center !important;
  }

  #okta-sign-in.auth-container .o-form-fieldset-container .o-form-input-name-phoneNumber span,
  .chzn-container .chzn-single span,
  .chzn-container .chzn-results .active-result
  {
    color: ${({ theme }) => theme.colors.text} !important;
    font-family: ${({ theme }) => theme.fontFamily.regular} !important;
    font-size: 14px !important;
  }

  #okta-sign-in.auth-container .enroll-manual-push .o-form-fieldset-container .chzn-single,
  #okta-sign-in.auth-container .o-form-input-name-phoneNumber .okta-form-label-inline
  {
    border-color: ${({ theme }) => theme.colors.gray13};
  }

  #okta-sign-in .o-form .o-form-input-name-sharedSecret.input-fix input[disabled]
  {
    background: ${({ theme }) => theme.colors.gray1};
    color: ${({ theme }) => theme.colors.text};
    -webkit-text-fill-color: ${({ theme }) => theme.colors.text};
  }

  #okta-sign-in .o-form .o-form-input-name-sharedSecret.input-fix.o-form-disabled
  {
    opacity: 1;
  }

  #okta-sign-in .enroll-activation-link-sent p,
  #okta-sign-in .webauthn-enroll-instructions p,
  #okta-sign-in .scan-instructions .scan-instructions-details p,
  #okta-sign-in .enroll-email .o-form-fieldset-container div
  {
    font-weight: bold;
  }

  #okta-sign-in.auth-container .auth-content
  {
    padding-top: 20px !important;
    max-width: none;
    padding-left: 16px;
    padding-right: 16px;

    ${media.sm`
      padding-left: 32px;
      padding-right: 32px;
    `}
  }

  #okta-sign-in.auth-container .primary-auth .okta-form-label.o-form-label
  {
    padding-top: 16px;
    padding-bottom: 12px;
  }

  #okta-sign-in.auth-container form.enroll-sms .okta-form-label.o-form-label,
  #okta-sign-in.auth-container form.enroll-call .okta-form-label.o-form-label
  {
    padding-top: 36px;
    padding-bottom: 12px;
  }

  #okta-sign-in.auth-container .o-form-fieldset.o-form-label-top
  {
    margin-bottom: 0 !important;
  }

  #okta-sign-in.auth-container div.enroll-manual-push form.o-form.o-form-edit-mode div.o-form-fieldset.o-form-label-top {
    margin-bottom: 36px !important;
  }

  #okta-sign-in.auth-container div.enroll-manual-push form.o-form.o-form-edit-mode div.o-form-fieldset.o-form-label-top:last-of-type {
    margin-bottom: 0 !important;
  }

  #okta-sign-in.auth-container .o-form-fieldset.o-form-label-top.margin-btm-30
  {
    padding-top: 19px !important;
    
  }

  #okta-sign-in.auth-container .o-form-button-bar,
  #okta-sign-in.auth-container [data-type=next-button-wrap]
  {
    padding-bottom: 12px;
  } 

  #okta-sign-in.auth-container div.enroll-email .o-form-button-bar
  {
    padding-bottom: 24px;
  } 

  #okta-sign-in.auth-container a.button.button-primary.button-wide.button-next.link-button
  {
    margin-bottom: 24px;
  } 

  #okta-sign-in.auth-container div.enroll-choices .o-form-button-bar,
  #okta-sign-in.auth-container form.mfa-verify-email .o-form-button-bar
  {
    padding-bottom: 12px;
  } 

  #okta-sign-in .registration-container a.registration-link,
  #okta-sign-in div.enroll-manual-push div.auth-footer a.link.goto,
  #okta-sign-in div.enroll-manual-totp div.auth-footer a.link.goto
  {
    position: relative;
    display: inline-block;
    height: 50px;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    background: transparent;
    color: ${({ theme }) => theme.colors.primary};
    padding: 0 32px;
    border-radius: 50px;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    -webkit-appearance: none;
    box-sizing: border-box;
    line-height: 46px;
    text-decoration: none !important;
    outline: none;
    white-space: nowrap;
    width: 100%;
  
    &:hover {
      color: ${({ theme }) => theme.colors.light};
      border: 2px solid ${({ theme }) => theme.colors.light};
    }
  
    &:active, &:focus {
      color: ${({ theme }) => theme.colors.blue10};
      border: 2px solid ${({ theme }) => theme.colors.blue10};
    }
  }

  #okta-sign-in div.enroll-manual-push div.auth-footer a.link.js-back,
  #okta-sign-in div.enroll-manual-totp div.auth-footer a.link.js-back
  {
    padding-top: 36px;
  }

  #okta-sign-in .auth-footer a.link.js-back,
  #okta-sign-in .auth-footer a.link.goto {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    white-space: nowrap;
    display: contents;
    float: left;

    &:active {
      color: ${({ theme }) => theme.colors.lighter};
      text-decoration: underline !important;
    }
  }

  #okta-sign-in .auth-footer a.link.js-back {
    padding-bottom: 36px;
  }

  #okta-sign-in .auth-footer a.link.goto {
    padding-bottom: 16px;
  }

  #okta-sign-in .auth-footer a.link.js-back:hover,
  #okta-sign-in .auth-footer a.link.goto:hover {
    color: ${({ theme }) => theme.colors.light};
    text-decoration: underline !important;
  }

  #okta-sign-in .auth-footer a.link.js-back:active,
  #okta-sign-in .auth-footer a.link.goto:active {
    color: ${({ theme }) => theme.colors.lighter};
    text-decoration: underline !important;
  }

  #okta-sign-in.auth-container .registration-container {
    margin-top: 36px;
  }

  #okta-sign-in.auth-container .registration-container .content-container {
    padding-top: 36px;
    padding-bottom: 36px;
  }

  #okta-sign-in .auth-footer .help,
  #okta-sign-in .auth-footer a.link.help.goto.js-signout,
  #okta-sign-in .auth-footer .js-help-link {
    display: none !important;
  }

  #okta-sign-in .auth-footer .help-links {
    display: block !important;
  }

  #okta-sign-in .auth-content .help-links.js-help-links li {
    margin-top: 16px;
  }

  #okta-sign-in .auth-footer .js-back,
  #okta-sign-in .auth-footer a.link.goto
   {
    display: block !important;
  }

  #okta-sign-in input[type=password]::-ms-reveal,
  #okta-sign-in input[type=password]::-ms-clear
  {
      display: none;
  }

  #okta-sign-in .custom-checkbox label {
    background:url(${rememberMeUnchecked}) no-repeat left center !important;
    height: auto;
    width: fit-content;
  }

  #okta-sign-in .custom-checkbox label.checked {
    background:url(${rememberMeChecked}) no-repeat left center !important;
  }

  #okta-sign-in .custom-checkbox label.focus {
    outline: 2px solid ${({ theme }) => theme.colors.light};
  }
  
  #okta-sign-in .default-custom-button.link-button:last-of-type {
    margin-bottom: 0px !important;
  }
  
  #okta-sign-in.auth-container .o-form-explain {
    padding-top: 10px;
  }

  #okta-sign-in .enroll-sms .sms-request-button {
    margin-top: 32px;
  }

  #okta-sign-in .call-request-button.link-button,
  #okta-sign-in .sms-request-button.link-button {
    margin-top: 36px !important;
  }

  #okta-sign-in .o-form-button-bar .button {
    margin-bottom: 24px !important;
    ${media.sm`
      margin-bottom: 12px !important;
    `}
  }

  #okta-sign-in div.enroll-choices .o-form-button-bar .button {
    margin-bottom: 24px !important;
  }

  #okta-sign-in.auth-container .primary-auth .o-form-content.o-form-theme.clearfix {
    padding-top: 0px;
  }

  #okta-sign-in a:active, 
  #okta-sign-in a:link, 
  #okta-sign-in a:visited {
    text-decoration: none;
  }

  #okta-sign-in a:focus, 
  #okta-sign-in a:hover {
    text-decoration: underline;
  }  

  #okta-sign-in .mfa-verify-passcode .link-button {
    float: inherit !important; 
    margin-top: 0px !important;
  }

  #okta-sign-in .mfa-verify-passcode .auth-passcode {
    float: inherit !important; 
    width: 100% !important;
  }

  #okta-sign-in a.button.call-request-button.link-button.link-button-disabled.btn-disabled.disabled,
  #okta-sign-in a.button.sms-request-button.link-button.link-button-disabled.btn-disabled.disabled {
    background: ${({ theme }) => theme.colors.disabled} !important;
    font-style: ${({ theme }) => theme?.Button?.disabledFontStyle} !important;
    cursor: default;
  }

  #okta-sign-in div.auth-beacon,
  #okta-sign-in div.auth-beacon-border {
    border: none;
    border-radius: 0;
  }

  #okta-sign-in div.bg-helper.auth-beacon.auth-beacon-factor.mfa-okta-sms,
  #okta-sign-in div.bg-helper.auth-beacon.auth-beacon-factor.mfa-okta-email,
  #okta-sign-in div.bg-helper.auth-beacon.auth-beacon-factor.mfa-okta-verify,
  #okta-sign-in div.bg-helper.auth-beacon.auth-beacon-factor.mfa-google-auth,
  #okta-sign-in div.bg-helper.auth-beacon.auth-beacon-factor.mfa-verify-push,
  #okta-sign-in div.bg-helper.auth-beacon.auth-beacon-factor.mfa-okta-call {
    cursor: default;
  }

  #okta-sign-in .mfa-sms-30,
  #okta-sign-in .mfa-call-30,
  #okta-sign-in .mfa-email-30,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-sms,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-call,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-email,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-google-auth,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-verify-push,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-verify,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-email {
    border-radius: 0 !important;
    border: none !important;
  }

  #okta-sign-in .factor-icon.mfa-okta-verify-30,
  #okta-sign-in .factor-icon.mfa-google-auth-30 {
    border: none !important;
  }

  #okta-sign-in div.o-form-fieldset.o-form-label-top.enroll-sms-phone,
  #okta-sign-in a.button.button-primary.js-enroll-phone.margin-top-30.sms-request-button.link-button,
  #okta-sign-in div.o-form-fieldset.o-form-label-top.enroll-call-phone
  {
    width: 100%;
  }

  #okta-sign-in .enroll-call .enroll-call-extension {
    float: left !important;
  }

  #okta-sign-in a.link-button.bg-helper.icon-button.link-button-icon.option-selected {
    display: none;
  }

  #okta-sign-in h2#verifyMfaTitleContainer {
    text-align: center;
    padding-bottom: 24px;
  }

  #okta-sign-in div#verifyMfaWarning {
    margin-top: 32px;
    margin-bottom: 16px;
  }

  #okta-sign-in h2#verifyMfaTitleContainer a::after {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 12' width='24'%3E%3Cpath d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' fill='%23003da5'/%3E%3C/svg%3E");
    margin-left: 4px;
  }

  #okta-sign-in h2#verifyMfaTitleContainer a {
    line-height: 1.29;
    letter-spacing: normal;
    color: ${({ theme }) => theme.colors.primary};
    padding: 11px 16px;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: 4px;
    text-decoration: none;
    text-wrap: nowrap;

    &:hover {
      color: ${({ theme }) => theme?.colors.light};
      border: 2px solid ${({ theme }) => theme.colors.light};
    }

    &:focus, &:active {
      color: ${({ theme }) => theme.colors.lighter};
      border: 2px solid ${({ theme }) => theme.colors.lighter};
    }

    @media only screen and (max-width: 360px){
      padding: 11px 6px;
    }
  }

  #okta-sign-in h2#verifyMfaTitleContainer span {
    line-height: 1.29;
    letter-spacing: normal;
    color: ${({ theme }) => theme.colors.black};
  }

  #okta-sign-in div#verifyMfaTitleHR {
    margin-bottom: 36px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray3};
    width: calc(100% + 64px);
    position: relative;
    left: -32px;
  }

  #okta-sign-in div.okta-form-divider.form-divider {
    margin-bottom: 36px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray3};
    width: calc(100% + 64px);
    position: relative;
    left: -32px;
    padding-top: 0;
    border-bottom: 0;
    top: 0;
  }

  #okta-sign-in div.enroll-sms div.okta-form-divider.form-divider,
  #okta-sign-in div.enroll-call div.okta-form-divider.form-divider {
    margin-bottom: 0px;
  }

  #okta-sign-in div#verifyMfaSubTitle {
    margin-bottom: 36px;
    line-height: 1.29;
    color: ${({ theme }) => theme.colors.black};
    font-size: 14px;
    font-style: normal;
    font-weight: bold;
    font-stretch: normal;
  }

  #okta-sign-in ul.okta-dropdown-list.options-wrap {
    overflow-y: hidden !important;
  }

  #okta-sign-in ul.okta-dropdown-list.options-wrap li.okta-dropdown-option.option a.dropdown-list-title,
  #okta-sign-in ul.okta-dropdown-list.options-wrap li.okta-dropdown-option.option a.factor-option {
    line-height: 1.29;
    letter-spacing: normal;
    color: ${({ theme }) => theme.colors.light};
    font-size: 14px !important;
    font-weight: 600;
    border-collapse: collapse;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  #okta-sign-in ul.okta-dropdown-list.options-wrap li.okta-dropdown-option.option a.dropdown-list-title {
    color: ${({ theme }) => theme.colors.black} !important;
  }

  #okta-sign-in div.factors-dropdown-wrap div.dropdown.more-actions ul.options-wrap {
    top: 115px;
  }

  #okta-sign-in div#okta-dropdown-options ul.okta-dropdown-list.options-wrap::before {
    position: absolute;
    top: -1px;
    left: calc(50% - 30px);
    content: url("data:image/svg+xml,%3Csvg width='60px' height='18px' viewBox='0 0 60 18' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cpath d='M0,0 L60,0 L52.627417,0 C48.3839532,7.88493902e-15 44.3142906,1.68570945 41.3137085,4.6862915 L30,16 L30,16 L18.6862915,4.6862915 C15.6857094,1.68570945 11.6160468,2.77320202e-15 7.372583,0 L0,0 L0,0 Z' fill='%23FFFFFF'%3E%3C/path%3E%3Cpath d='M0,0 L7.372583,0 C11.6160468,2.77320202e-15 15.6857094,1.68570945 18.6862915,4.6862915 L30,16 L30,16 L41.3137085,4.6862915 C44.3142906,1.68570945 48.3839532,7.79511661e-16 52.627417,0 L60,0 L60,0' stroke='%23BBC2CA'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }

  .hidden {
    display: none;
  }

  #okta-sign-in div#verifyMfaWarning div.login-timeout-warning,
  #okta-sign-in div.infobox.infobox-warning {
    background-color: ${({ theme }) => theme.colors.blue12};
    border: 1px solid ${({ theme }) => theme.colors.light};
  }

  #okta-sign-in span.warning-16:before {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%232062d4' d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z'%3E%3C/path%3E%3C/svg%3E");
    margin-top: 12px;
  }

  #okta-sign-in div.mfa-email-sent-content,
  #okta-sign-in div.mfa-send-email-content,
  #okta-sign-in div.enroll-activate-email-content,
  #okta-sign-in form.mfa-verify-email span.mask-email,
  #okta-sign-in div.enroll-activate-email-content span.mask-email {
    font-weight: 700;
  }

  #okta-sign-in div.mfa-send-email-content {
    padding-bottom: 24px;
  }


  #okta-sign-in form.no-verify-button div.o-form-button-bar {
    display: none;
  }

  #okta-sign-in a.resend-code-btn,
  #okta-sign-in a.resend-code-btn-enroll,
  #okta-sign-in .mfa-verify-email a.resend-email-btn {
    color: ${({ theme }) => theme.colors.light};
  }

  #okta-sign-in div.enroll-choices form.o-form-edit-mode h2.okta-form-title.o-form-head {
    display: none;
  }

  #okta-sign-in div.enroll-choices {
    padding-bottom: 0;
  }

  #okta-sign-in form.o-form-edit-mode h2.okta-form-title.o-form-head {
    color: ${({ theme }) => theme.colors.black};
  }

  #okta-sign-in .enroll-factor-list h3.list-title {
    color: ${({ theme }) => theme.colors.gray14};
  }

  #okta-sign-in input[type=checkbox].checkedFocus:focus {
    outline: 2px solid ${({ theme }) => theme.colors.light};
  }

  #okta-sign-in .enroll-email .o-form-content.o-form-theme {
    margin-bottom: 0px !important;
  }

  #okta-sign-in ul.list-content li:last-child,
  #okta-sign-in .enroll-factor-list:last-child {
    margin-bottom: 0px;
  }

  #okta-sign-in div.app-download-instructions {
    padding-top: 36px;
    padding-bottom: 21px;
  }

  #okta-sign-in div.barcode-push div.scan-instructions.clearfix,
  #okta-sign-in div.barcode-totp div.o-form-content div.scan-instructions.clearfix { 
    padding-top: 0;
  }

  #okta-sign-in.auth-container div.auth-beacon.mfa-google-auth,
  #okta-sign-in.auth-container div.auth-beacon.mfa-okta-verify {
    background-size: 68px 68px;
  }

  #okta-sign-in div.enroll-totp div.app-download-instructions {
    margin-bottom: 0;
  }

  #okta-sign-in p.instructions a.inline-link,
  #okta-sign-in.auth-container a.link.refresh-qrcode:link,
  #okta-sign-in.auth-container a.link.manual-setup:link {
    text-decoration: underline;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary};
    &:focus, &:active {
      color: ${({ theme }) => theme.colors.lighter} !important;
    }
    &:hover {
      color: ${({ theme }) => theme?.colors.light};
    }
  }

  #okta-sign-in li.enroll-factor-row div.enroll-factor-icon.mfa-okta-verify,
  #okta-sign-in li.enroll-factor-row div.enroll-factor-icon.mfa-google-auth {
    background-size: 48px 48px;
  }

  #okta-sign-in div.mfa-verify .custom-checkbox
  {
    padding-top: 12px;
    padding-bottom: 24px;
  }

  #okta-sign-in form.mfa-verify-totp.o-form.o-form-edit-mode .custom-checkbox,
  #okta-sign-in form.mfa-verify-passcode.o-form.o-form-edit-mode .custom-checkbox,
  #okta-sign-in form.mfa-verify-email.o-form.o-form-edit-mode .custom-checkbox
  {
    padding-top: 36px;
  }

  #okta-sign-in.auth-container div.mfa-verify .o-form-content.o-form-theme.clearfix {
    padding-bottom: 12px;
  }

  #okta-sign-in form.mfa-verify-passcode.o-form.o-form-edit-mode a.sms-request-button,
  #okta-sign-in form.mfa-verify-passcode.o-form.o-form-edit-mode a.call-request-button
  {
    margin-bottom: 24px;
  }

  #okta-sign-in form.mfa-verify-email div.mfa-email-sent-content {
    margin-bottom: 36px;
  }

  #okta-sign-in div.enroll-manual-push form.o-form.o-form-edit-mode div.o-form-fieldset-container div.okta-form-label.o-form-label
  {
    padding-top: 0;
  }

  #okta-sign-in div.enroll-manual-push .chzn-container {
    padding: 2px;
  }

  .chzn-container:focus-within,
  #okta-sign-in div.enroll-manual-push .chzn-container:focus-within {
    box-shadow: none;
    outline: none;
    border-color: ${({ theme }) => theme?.colors.blue10} !important;
    border: solid 2px ${({ theme }) => theme?.colors.blue10};
    border-radius: ${({ theme }) => theme?.Input?.borderRadius};
    padding: 0;
  }

  #okta-sign-in div.enroll-manual-push .secret-key-instructions .shared-key:focus,
  #okta-sign-in div.enroll-manual-totp .secret-key-instructions .shared-key:focus {
    box-shadow: none;
  }

  #okta-sign-in div.scan-instructions-qrcode-wrapper div.qrcode-success
  {
    background: ${({ theme }) => theme.colors.gray1};
  }

  #okta-sign-in div.scan-instructions-qrcode-wrapper div.qrcode-error
  {
    background: transparent;
  }

  #okta-sign-in div.enroll-manual-push div.secret-key-instructions p.shared-key,
  #okta-sign-in div.enroll-manual-totp div.secret-key-instructions p.shared-key
  {
    background: ${({ theme }) => theme.colors.gray1};
    padding: 24px 0;
    margin: 36px 0;
  }

  #okta-sign-in.auth-container div.enroll-manual-totp .o-form-button-bar,
  #okta-sign-in.auth-container div.enroll-manual-push .o-form-button-bar
  {
    padding-bottom: 12px;
  } 
`;
